export const BuildHash = 'f123f502';